export default __webpack_public_path__ + "static/media/reporting-people.bc1b6dc7.png";